import React, { useState } from 'react';
import * as Yup from 'yup';
import { Button, Col, CompositeView, CrudContext, CrudMasterDetailView, FormNumber, FormSubmitButton, GridView, MasterDetailForm, Row, Widget, useRouter, } from '@digital/ui';
import { createOrcadoAnoNaoPrevisto, exportaModelo, getAllOrcadoAnoNaoPrevisto, updateOrcadoAnoNaoPrevisto } from '@app/api/naoPrevistos/parametros';
import { hasPermission } from '@app/helpers/permissions';
import { CurrencyInput3 } from '@app/components/CurrencyInput3';
import UploadFileDefault from '@app/components/uploadFileDefault';
import ProjetosTable from './ProjetosTable';


const CadastroOrcadoAno = () => {


    const { history } = useRouter();
    const [orcadoAnoNaoPrevisto, setOrcadoAnoNaoPrevisto] = useState(() => getAllOrcadoAnoNaoPrevisto);
    const [reloadProjetos, setReloadProjetos] = useState(false)
    const maxYear = new Date().getFullYear() + 1;
    const minYear = new Date().getFullYear();
    const enderecoApi = 'NaoPrevistoParametros/ImportarProjetos';

    const validationSchemaNovo = Yup.object().shape({
        ano: Yup.number()
            .required('Ano deve ser informado')
            .min(minYear, `O Ano não pode ser menor que ${minYear}.`)
            .max(maxYear, `O Ano não pode ser maior que ${maxYear}.`)
    });

    const validationSchema = Yup.object().shape({
        valorAprovadoCnp: Yup.number().nullable().required('Campo obrigatório'),
        valorAprovadoOnp: Yup.number().nullable().required('Campo obrigatório'),
        valorDolar: Yup.number().nullable().required('Campo obrigatório'),
        valorEuro: Yup.number().nullable().required('Campo obrigatório'),
    });

    const onCreate = (values: any) => {
        return createOrcadoAnoNaoPrevisto(values).then((resp: any) => {
            if (resp && resp.valid) reloadList();
            return resp;
        });
    };

    const onUpdate = (values: any) => {
        return updateOrcadoAnoNaoPrevisto(values).then((resp: any) => {
            return resp;
        });
    };

    const reloadList = () => {
        setOrcadoAnoNaoPrevisto(() => Promise.resolve(undefined));
        setOrcadoAnoNaoPrevisto(() => getAllOrcadoAnoNaoPrevisto);
    };

    const onReloadProjetos = () => {
        setReloadProjetos(!reloadProjetos);
    };

    const getButtonForm = (selectedItem: any) => {

        if (selectedItem == undefined) {
            return [
                hasPermission(['NAO_PREVISTO_PARAMETROS_EDITAR', 'NAO_PREVISTO_PARAMETROS_EDITAR']) && (
                    [
                        <FormSubmitButton type="primary" title='Salvar' />,
                    ]
                ),
            ]
        }

        return [
            <Button
                title='Modelo'
                type='link'
                icon="files-xls"
                onClick={() => {
                    exportaModelo();
                }}
            />,
            hasPermission([
                'NAO_PREVISTO_PARAMETROS_EDITAR',
                'NAO_PREVISTO_PARAMETROS_EDITAR',
            ]) && (
                [
                    <FormSubmitButton type="primary" title='Salvar' />,
                    <UploadFileDefault
                        descricaoBotao="Importar"
                        id={selectedItem && selectedItem.id}
                        idDoComponente={'btnImportFilePlanilha'}
                        enderecoApi={enderecoApi}
                        nomeIdFormulario={'id'}
                        retorno={() => onReloadProjetos()}
                        type="link"
                    />,
                ]
            ),
        ]


        return [];
    };

    return (
        <CrudMasterDetailView
            disableNotification
            getAllItems={orcadoAnoNaoPrevisto}
            createItem={hasPermission(['NAO_PREVISTO_PARAMETROS_EDITAR']) ? onCreate : undefined}
            updateItem={hasPermission(['NAO_PREVISTO_PARAMETROS_EDITAR']) ? onUpdate : undefined}
            icon="business-flow_chart"
            titleExtractor={item => item.ano.toString()}
            descriptionExtractor={() => ''}
            filterPredicate={(item, value) =>
                item.ano.toString().includes(value)
            }
            key={'id'}
        >
            <CompositeView>
                <CrudContext.Consumer>
                    {({ selectedItem }) => (
                        <GridView noform key={selectedItem ? selectedItem.id : 'new'}>
                            <MasterDetailForm
                                validationSchema={selectedItem ? validationSchema : validationSchemaNovo}
                                initialValues={selectedItem}
                            >
                                <Widget
                                    id='widgetOrcadoAnoNaoPrevistoForm'
                                    actions={getButtonForm(selectedItem)}
                                >
                                    <Row>
                                        <Col span={3}>
                                            <FormNumber
                                                step={1}
                                                min={1900}
                                                max={maxYear}
                                                label="Ano"
                                                name="ano"
                                                span={12}
                                                disabled={selectedItem && selectedItem.hasOwnProperty('id')}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        {
                                            selectedItem && (
                                                <>
                                                    <Col span={3}>
                                                        <CurrencyInput3
                                                            id='valorAprovadoCnpForm'
                                                            name='valorAprovadoCnp'
                                                            label="Valor Aprovado CNP"
                                                            defaultValue={selectedItem.valorAprovadoCnp}
                                                            required
                                                        />
                                                    </Col>
                                                    <Col span={3}>
                                                        <CurrencyInput3
                                                            id='valorAprovadoOnpForm'
                                                            name='valorAprovadoOnp'
                                                            label="Valor Aprovado ONP"
                                                            defaultValue={selectedItem.valorAprovadoOnp}
                                                            required
                                                        />
                                                    </Col>
                                                    <Col span={3}>
                                                        <CurrencyInput3
                                                            id='valorDolarForm'
                                                            name='valorDolar'
                                                            label="Valor Dólar"
                                                            defaultValue={selectedItem.valorDolar}
                                                            required
                                                        />
                                                    </Col>
                                                    <Col span={3}>
                                                        <CurrencyInput3
                                                            id='valorEuroForm'
                                                            name='valorEuro'
                                                            label="Valor Euro"
                                                            defaultValue={selectedItem.valorEuro}
                                                            required
                                                        />
                                                    </Col>
                                                </>
                                            )
                                        }
                                    </Row>
                                </Widget>
                                {selectedItem &&
                                    <ProjetosTable orcadoAnoNaoPrevistoId={selectedItem.id} reload={reloadProjetos} />
                                }
                            </MasterDetailForm>
                        </GridView>
                    )}
                </CrudContext.Consumer>
            </CompositeView>
        </CrudMasterDetailView >
    );
};

export default CadastroOrcadoAno;
